/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SettlementPeriodDto
 */
export interface SettlementPeriodDto {
    /**
     * 
     * @type {Date}
     * @memberof SettlementPeriodDto
     */
    from: Date;
    /**
     * 
     * @type {string}
     * @memberof SettlementPeriodDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof SettlementPeriodDto
     */
    to: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SettlementPeriodDto
     */
    closed?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof SettlementPeriodDto
     */
    locationId?: number | null;
}

/**
 * Check if a given object implements the SettlementPeriodDto interface.
 */
export function instanceOfSettlementPeriodDto(value: object): value is SettlementPeriodDto {
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function SettlementPeriodDtoFromJSON(json: any): SettlementPeriodDto {
    return SettlementPeriodDtoFromJSONTyped(json, false);
}

export function SettlementPeriodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettlementPeriodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'from': (new Date(json['from'])),
        'id': json['id'],
        'to': (new Date(json['to'])),
        'closed': json['closed'] === undefined ? undefined : json['closed'] === null ? null : json['closed'],
        'locationId': json['locationId'] === undefined ? undefined : json['locationId'] === null ? null : json['locationId'],
    };
}

export function SettlementPeriodDtoToJSON(json: any): SettlementPeriodDto {
    return SettlementPeriodDtoToJSONTyped(json, false);
}

export function SettlementPeriodDtoToJSONTyped(value?: SettlementPeriodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'].toISOString(),
        'id': value['id'],
        'to': value['to'].toISOString(),
        'closed': value['closed'],
        'locationId': value['locationId'],
    };
}

